module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"goBackToPreviousPage":"Go back to previous page","myQualificationStatus":"My qualifications status","userQualificationStatus":"{0} - Qualifications status"},"fr":{"goBackToPreviousPage":"Retour à la page précédente","myQualificationStatus":"Etat de mes qualifications","userQualificationStatus":"{0} - Etat des qualifications"}}')
  delete Component.options._Ctor
}
